import { render, staticRenderFns } from "./QuestionTypeFloat.vue?vue&type=template&id=180fb550"
import script from "./QuestionTypeFloat.vue?vue&type=script&lang=js"
export * from "./QuestionTypeFloat.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeFloat.vue?vue&type=style&index=0&id=180fb550&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports